export const handleDownloadFile = (res: Blob, filename: string) => {
	const href = window.URL.createObjectURL(new Blob([res]));
	const link = document.createElement('a');
	link.href = href;
	link.download = String(filename);
	link.click();
	link.remove();
};
